$(document).ready(function () {
  $(".client-testimonial-carousel").slick({
    slidesToShow: 3.1, // Number of slides visible at a time
    infinite: false,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg class="arrow-ani arrow-svg-1" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-path-1 hover-text top" d="M21.2002 11.8507L5.9215 11.8507C7.64925 10.5786 10.19 8.4106 10.19 4.68384L8.49618 4.68384C8.49618 10.8025 2.27121 11.8507 2.00019 11.8507L2.00019 13.517C2.27121 13.517 8.49618 14.5651 8.49618 20.6838L10.19 20.6838C10.19 16.9571 7.64078 14.7891 5.9215 13.517L21.2002 13.517L21.2002 11.8507Z" fill="#A53500"/><path class="arrow-path-1 hover-text bottom" d="M21.2002 11.8507L5.9215 11.8507C7.64925 10.5786 10.19 8.4106 10.19 4.68384L8.49618 4.68384C8.49618 10.8025 2.27121 11.8507 2.00019 11.8507L2.00019 13.517C2.27121 13.517 8.49618 14.5651 8.49618 20.6838L10.19 20.6838C10.19 16.9571 7.64078 14.7891 5.9215 13.517L21.2002 13.517L21.2002 11.8507Z" fill="#A53500"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg class="arrow-ani-2 arrow-svg-2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-path-2 hover-text top" d="M2 13.517H17.2787C15.551 14.7891 13.0101 16.9571 13.0101 20.6838H14.704C14.704 14.5651 20.929 13.517 21.2 13.517V11.8507C20.929 11.8507 14.704 10.8025 14.704 4.68384H13.0101C13.0101 8.4106 15.5594 10.5786 17.2787 11.8507H2V13.517Z" fill="#A53500"/><path class="arrow-path-2 hover-text bottom" d="M2 13.517H17.2787C15.551 14.7891 13.0101 16.9571 13.0101 20.6838H14.704C14.704 14.5651 20.929 13.517 21.2 13.517V11.8507C20.929 11.8507 14.704 10.8025 14.704 4.68384H13.0101C13.0101 8.4106 15.5594 10.5786 17.2787 11.8507H2V13.517Z" fill="#A53500"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2.1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1.25 },
      },
    ],
  });
  $(".featured-collection-carousel:not(.swiper-featured-collection-carousel)").slick({
    slidesToShow: 4, // Number of slides visible at a time
    infinite: false,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg class="arrow-ani arrow-svg-1" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-path-1 hover-text top" d="M21.2002 11.8507L5.9215 11.8507C7.64925 10.5786 10.19 8.4106 10.19 4.68384L8.49618 4.68384C8.49618 10.8025 2.27121 11.8507 2.00019 11.8507L2.00019 13.517C2.27121 13.517 8.49618 14.5651 8.49618 20.6838L10.19 20.6838C10.19 16.9571 7.64078 14.7891 5.9215 13.517L21.2002 13.517L21.2002 11.8507Z" fill="#A53500"/><path class="arrow-path-1 hover-text bottom" d="M21.2002 11.8507L5.9215 11.8507C7.64925 10.5786 10.19 8.4106 10.19 4.68384L8.49618 4.68384C8.49618 10.8025 2.27121 11.8507 2.00019 11.8507L2.00019 13.517C2.27121 13.517 8.49618 14.5651 8.49618 20.6838L10.19 20.6838C10.19 16.9571 7.64078 14.7891 5.9215 13.517L21.2002 13.517L21.2002 11.8507Z" fill="#A53500"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg class="arrow-ani-2 arrow-svg-2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-path-2 hover-text top" d="M2 13.517H17.2787C15.551 14.7891 13.0101 16.9571 13.0101 20.6838H14.704C14.704 14.5651 20.929 13.517 21.2 13.517V11.8507C20.929 11.8507 14.704 10.8025 14.704 4.68384H13.0101C13.0101 8.4106 15.5594 10.5786 17.2787 11.8507H2V13.517Z" fill="#A53500"/><path class="arrow-path-2 hover-text bottom" d="M2 13.517H17.2787C15.551 14.7891 13.0101 16.9571 13.0101 20.6838H14.704C14.704 14.5651 20.929 13.517 21.2 13.517V11.8507C20.929 11.8507 14.704 10.8025 14.704 4.68384H13.0101C13.0101 8.4106 15.5594 10.5786 17.2787 11.8507H2V13.517Z" fill="#A53500"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 3.1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2.25 },
      },
    ],
  });

  function setEqualSlideHeight(carousel) {
    let maxHeight = 0;
    carousel.find('.grid-cards-item').css('height', 'auto');
    carousel.find('.grid-cards-item').each(function () {
      let h = $(this).outerHeight();
      if (h > maxHeight) maxHeight = h;
    });
    carousel.find('.grid-cards-item').css('height', maxHeight + 'px');
  }

  let $carousel = $(".grid-cards-row");

  $carousel.slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="arrow-ani arrow-svg-1" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-path-1 hover-text top" d="M21.2002 11.8507L5.9215 11.8507C7.64925 10.5786 10.19 8.4106 10.19 4.68384L8.49618 4.68384C8.49618 10.8025 2.27121 11.8507 2.00019 11.8507L2.00019 13.517C2.27121 13.517 8.49618 14.5651 8.49618 20.6838L10.19 20.6838C10.19 16.9571 7.64078 14.7891 5.9215 13.517L21.2002 13.517L21.2002 11.8507Z" fill="#CDF0D1"/><path class="arrow-path-1 hover-text bottom" d="M21.2002 11.8507L5.9215 11.8507C7.64925 10.5786 10.19 8.4106 10.19 4.68384L8.49618 4.68384C8.49618 10.8025 2.27121 11.8507 2.00019 11.8507L2.00019 13.517C2.27121 13.517 8.49618 14.5651 8.49618 20.6838L10.19 20.6838C10.19 16.9571 7.64078 14.7891 5.9215 13.517L21.2002 13.517L21.2002 11.8507Z" fill="#CDF0D1"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="arrow-ani-2 arrow-svg-2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-path-2 hover-text top" d="M2 13.517H17.2787C15.551 14.7891 13.0101 16.9571 13.0101 20.6838H14.704C14.704 14.5651 20.929 13.517 21.2 13.517V11.8507C20.929 11.8507 14.704 10.8025 14.704 4.68384H13.0101C13.0101 8.4106 15.5594 10.5786 17.2787 11.8507H2V13.517Z" fill="#CDF0D1"/><path class="arrow-path-2 hover-text bottom" d="M2 13.517H17.2787C15.551 14.7891 13.0101 16.9571 13.0101 20.6838H14.704C14.704 14.5651 20.929 13.517 21.2 13.517V11.8507C20.929 11.8507 14.704 10.8025 14.704 4.68384H13.0101C13.0101 8.4106 15.5594 10.5786 17.2787 11.8507H2V13.517Z" fill="#CDF0D1"/></svg></button>',
    responsive: [
      { breakpoint: 769, settings: { slidesToShow: 2.5, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1.2, slidesToScroll: 1 } }
    ]
  });

  $carousel.on('setPosition', function () {
    setEqualSlideHeight($carousel);
  });

  $(window).on('resize', function () {
    setEqualSlideHeight($carousel);
  });

  $(".announcement-carousel").slick({
    slidesToShow: 1, // Number of slides visible at a time
    infinite: true,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow:
      '<button type="button" class="slick-prev"><svg class="arrow-ani arrow-svg-1" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-path-1 hover-text top" d="M21.2002 11.8507L5.9215 11.8507C7.64925 10.5786 10.19 8.4106 10.19 4.68384L8.49618 4.68384C8.49618 10.8025 2.27121 11.8507 2.00019 11.8507L2.00019 13.517C2.27121 13.517 8.49618 14.5651 8.49618 20.6838L10.19 20.6838C10.19 16.9571 7.64078 14.7891 5.9215 13.517L21.2002 13.517L21.2002 11.8507Z" fill="#cbe7c6"/><path class="arrow-path-1 hover-text bottom" d="M21.2002 11.8507L5.9215 11.8507C7.64925 10.5786 10.19 8.4106 10.19 4.68384L8.49618 4.68384C8.49618 10.8025 2.27121 11.8507 2.00019 11.8507L2.00019 13.517C2.27121 13.517 8.49618 14.5651 8.49618 20.6838L10.19 20.6838C10.19 16.9571 7.64078 14.7891 5.9215 13.517L21.2002 13.517L21.2002 11.8507Z" fill="#cbe7c6"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg class="arrow-ani-2 arrow-svg-2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-path-2 hover-text top" d="M2 13.517H17.2787C15.551 14.7891 13.0101 16.9571 13.0101 20.6838H14.704C14.704 14.5651 20.929 13.517 21.2 13.517V11.8507C20.929 11.8507 14.704 10.8025 14.704 4.68384H13.0101C13.0101 8.4106 15.5594 10.5786 17.2787 11.8507H2V13.517Z" fill="#cbe7c6"/><path class="arrow-path-2 hover-text bottom" d="M2 13.517H17.2787C15.551 14.7891 13.0101 16.9571 13.0101 20.6838H14.704C14.704 14.5651 20.929 13.517 21.2 13.517V11.8507C20.929 11.8507 14.704 10.8025 14.704 4.68384H13.0101C13.0101 8.4106 15.5594 10.5786 17.2787 11.8507H2V13.517Z" fill="#cbe7c6"/></svg></button>',    
  });

  const carousels = document.querySelectorAll(".featured-collection-carousel");
  if (!carousels.length) return;

  carousels.forEach(function (carousel) {
    const swiperEl = carousel.querySelector(".fc-swiper");
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      slidesPerView: 4,
      spaceBetween: 15,
      loop: false,
      watchOverflow: true,

      // Scoped to THIS carousel instance
      navigation: {
        prevEl: carousel.querySelector(".fc-swiper-prev"),
        nextEl: carousel.querySelector(".fc-swiper-next"),
      },
  mousewheel: {
    releaseOnEdges: true,
  },

      pagination: {
        el: carousel.querySelector(".fc-swiper-pagination"),
        clickable: true,
      },

      freeMode: false,

      breakpoints: {
        0: {
          slidesPerView: 2.4,
          spaceBetween: 12,
          watchSlidesProgress: true,   // ← add this
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.6,
          },
        },
        480: {
          slidesPerView: 2.5,
          spaceBetween: 12,
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.6,
          },
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 15,
          freeMode: false,
        },
      },
    });
  });

});
